import { RECEIVED_POSTS_SUCCESSFULLY, RECEIVED_POSTS_UNSUCCESSFULLY, REQUEST_POSTS, LoadMoreAction } from '../loadMore.actions';
import { Section, Article } from '../template.state.types';

export interface FeedPageState {
  topSection: Section
  feedSection: Section
}

export type FeedPageSectionNames = 'topSection' | 'feedSection';

export const feedPageReducer = (state: FeedPageState = {} as FeedPageState, action: LoadMoreAction<FeedPageSectionNames>) => {
  switch (action.type) {
    case RECEIVED_POSTS_SUCCESSFULLY: {
      return {
        ...state,
        [action.sectionKey]: {
          ...state[action.sectionKey],
          articles: [
            ...state[action.sectionKey].articles,
            ...action.articles,
          ],
          next: action.next,
        },
      };
    }
    case RECEIVED_POSTS_UNSUCCESSFULLY: {
      return state;
    }

    case REQUEST_POSTS: {
      return state;
    }
    default:
      return state;
  }
};
